import { module as BaseModule } from 'modujs'
import gsap from 'gsap'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.$items = this.$('item')
  }

  setActive(index) {
    this.$items.forEach((card, i) => card.classList.toggle('is-inview', i === index))
  }

  init() {
    const mm = gsap.matchMedia()

    mm.add('(max-width: 1199px)', () => {
      this.$items.forEach((card, index) => {
        gsap.to(card, {
          ease: 'linear',
          scrollTrigger: {
            trigger: card,
            start: 'top 50%',
            end: 'bottom 50%',
            onEnter: () => {
              this.setActive(index)
            },
            onEnterBack: () => {
              this.setActive(index)
            },
            onLeave: () => {
              this.setActive(index)
            },
            onLeaveBack: () => {
              this.setActive(index)
            },
          },
        })
      })
    })
  }
}
